export default {
  title: `CSS Modules by Example`,
  path: `/css-modules-by-example`,
  subtitle: `CSS Modules are super trendy and super useful. Learn how they work, visually, by example`,
  date: new Date(2016, 3, 27),
  update_date: new Date(2018, 0, 14)
};



// WEBPACK FOOTER //
// ./src/guides/css-modules-by-example/frontmatter.js